import { useCallback } from 'react';
import NiceModal from '@ebay/nice-modal-react';

import UiVideoIcon from '@/icons/UiVideoIcon';
import UiMicrophoneIcon from '@/icons/UiMicrophoneIcon';

import { modals } from '@/modals';
import PermissionRow from '@/app/pages/LobbyPage/PermissionRow';
import { Permission, RequestPermissions } from '@/app/types';

import './LobbyPage.css';
import { EVENTS, gtag } from '@/lib/gtag';

const DEVICE_NAME: Record<Permission, string> = {
  audio: 'Microphone',
  video: 'Camera',
}

const DEVICE_ICON: Record<Permission, typeof UiVideoIcon> = {
  audio: UiMicrophoneIcon,
  video: UiVideoIcon,
}

export default function PermissionLine({
  permission, hasPermission, requestPermissions
}: { permission: Permission, hasPermission?: boolean, requestPermissions: RequestPermissions }) {
  const onRequestPermissions = useCallback(() => {
    requestPermissions({ [permission]: true }).catch(() => {
      // missing permissions
      const permissions = { [permission]: true };

      gtag(EVENTS.SHOW_MODAL, permissions);
      NiceModal.show(modals.RESET_PERMISSIONS_MODAL, { permissions });
    });
  }, [requestPermissions, permission]);

  return (
    <PermissionRow
      Icon={DEVICE_ICON[permission]}
      granted={Boolean(hasPermission)}
      name={DEVICE_NAME[permission]}
      onEnable={onRequestPermissions}
    />
  );
}
